import inquirer from "inquirer";
import fs from "fs";
import path from "path";
import chalk from "chalk";

export const initCommand = async () => {
  console.log(chalk.cyan("🚀 GMM Integration Setup\n"));

  const answers = await inquirer.prompt([
    {
      name: "folder",
      message: "Project root folder:",
      default: "./",
    },
    {
      name: "fileName",
      message: "Checkout file name (without extension):",
      default: "checkout",
    },
    {
      name: "lang",
      type: "list",
      message: "Choose file type:",
      choices: ["TypeScript", "JavaScript"],
      default: "TypeScript",
    },
    {
      name: "showEnv",
      type: "confirm",
      message: "Show .env setup instructions?",
      default: true,
    },
    {
      name: "installDeps",
      type: "confirm",
      message: "Show install commands?",
      default: true,
    },
  ]);

  // 1. Fix extension handling
  const ext = answers.lang === "TypeScript" ? "ts" : "js";
  const fileName = `${answers.fileName}.${ext}`;

  const filePath = path.join(answers.folder, fileName);

  // 2. Create ONLY file (not project)
  const fileContent = `
import { GMMGateway } from "gmm-gateway";
import dotenv from "dotenv";
dotenv.config();

const gmm = new GMMGateway({
  apiKey: process.env.GMM_API_KEY!,
  apiSecret: process.env.GMM_API_SECRET!,
  origin: process.env.GMM_ORIGIN!,
  environment: "sandbox",
});

async function run() {
  const session = await gmm.sessions.createCheckout({
    customer_email: "test@example.com",
    currency: "USD",
    items: [
      { id: 1, name: "Product", quantity: 1, price: 1000 }
    ],
    metadata: { orderId: "12345", customerId: "67890",  },
  });

  console.log("Checkout URL:", session.checkout_url);
}

run();
`;

  fs.writeFileSync(filePath, fileContent);

  console.log(chalk.green("\n✅ File created successfully!"));
  console.log(chalk.white(`📄 ${filePath}`));

  // 3. ENV instructions (not silent creation)
  if (answers.showEnv) {
    console.log(chalk.yellow("\n🔐 ENV Setup Required:"));
    console.log(`
Create a .env file in your project root:

GMM_API_KEY=your_key
GMM_API_SECRET=your_secret
GMM_ORIGIN=http://localhost:3000
`);
  }

  // 4. Dependencies instructions
  if (answers.installDeps) {
    console.log(chalk.blue("\n📦 Install dependencies:"));
    console.log(`
npm install gmm-gateway dotenv
    `);
  }

  console.log(chalk.green("\n🚀 You're ready to use GMM Gateway"));
};
